/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li3_LabelInputs */

const tr_onbilgi_s11_li3_label = /** @type {(inputs: Onbilgi_S11_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşletim sistemi:`)
};

const en_onbilgi_s11_li3_label = /** @type {(inputs: Onbilgi_S11_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operating system:`)
};

const de_onbilgi_s11_li3_label = /** @type {(inputs: Onbilgi_S11_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betriebssystem:`)
};

const ru_onbilgi_s11_li3_label = /** @type {(inputs: Onbilgi_S11_Li3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Операционная система:`)
};

/**
* | output |
* | --- |
* | "Operating system:" |
*
* @param {Onbilgi_S11_Li3_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li3_label = /** @type {((inputs?: Onbilgi_S11_Li3_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li3_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li3_label(inputs)
	if (locale === "de") return de_onbilgi_s11_li3_label(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li3_label(inputs)
	return tr_onbilgi_s11_li3_label(inputs)
});